import { fetchFollows } from 'utils/queries/follows'

import { Follow } from 'types/follow'

import { useQuery } from './useQuery'

/// Returns the users who are followed by `current user`
export const useFollows = (userId: string | undefined) => {
  const followQuery = useQuery<Array<Follow> | null>(['follows', userId], () =>
    fetchFollows({ userId }),
  )

  const result =
    !Array.isArray(followQuery.data) && followQuery.data ? [followQuery.data] : followQuery.data

  return {
    ...followQuery,
    data: result,
  }
}
